import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSwipeable } from 'react-swipeable'
import Area from '../../assets/menuUser/area-cliente.svg'
import Historia from '../../assets/menuUser/historia-rodi.svg'
import Datos from '../../assets/menuUser/mis-datos.svg'
import Logout from '../../assets/menuUser/logout.svg'
import Facturas from '../../assets/menuUser/mis-facturas.svg'
import Pedidos from '../../assets/menuUser/mis-pedidos.svg'
import makeTabs from '../../helpers/areaPrivadaTabs'
import route from '../../utils/route'
import styles from './menuUserMobile.module.scss'
import { connect } from 'react-redux'
import { IAppState } from '../../context/context'
import { selectFullName } from '../../context/selectors/userSelectors'
import { Route } from '../../../specific/constants/menu'

const icons = {
  logout: <Logout />,
  facturas: <Facturas />,
  historia: <Historia />,
  datos: <Datos />,
  area: <Area />,
  pedidos: <Pedidos />,
}

interface LinkMenuProps {
  name: string
  r: Route | string
  icon?: string
}
const LinkMenu = ({ name, r, icon }: LinkMenuProps) => {
  if (!r) {
    return <FormattedMessage id={name} />
  }

  if (typeof r === 'string') {
    return (
      <a className={styles.menu_title} href={r}>
        <div className={styles.name_icon}>
          {icon ? icons[icon] : null}
          <span className={icon ? styles.name : ''}>{name}</span>
        </div>
      </a>
    )
  }

  const { path, ...rest } = r
  return (
    <a className={styles.menu_title} href={route(path, rest)}>
      <FormattedMessage id={name} />
    </a>
  )
}

LinkMenu.propTypes = {
  name: PropTypes.string.isRequired,
  r: PropTypes.any.isRequired,
}
const tabs = makeTabs(true)

interface MenuUserMobileProps {
  userName: string
  open: boolean
  onLogout: () => void
  close: () => void
}
const MenuUserMobile = ({
  userName,
  open,
  onLogout,
  close,
}: MenuUserMobileProps) => {
  const handlers = useSwipeable({
    onSwipedRight: () => close(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    delta: 50,
  })

  return (
    <div
      {...handlers}
      className={open ? `${styles.menu} ${styles.open}` : styles.menu}>
      <div
        className={
          open
            ? `${styles.menu_user_mobile} ${styles.open}`
            : styles.menu_user_mobile
        }>
        <div className={styles.yellow_footer}>
          <div className={styles.phone}>{userName}</div>
        </div>
        {tabs.slice(0, 5).map((i, index) => (
          <LinkMenu key={index} name={i.name} r={i.route} icon={i.icon} />
        ))}

        <a className={styles.menu_exit} onClick={onLogout} href="#">
          {tabs[5].icon ? icons[tabs[5].icon] : null}
          <span className={styles.name}>{tabs[5].name}</span>
        </a>
      </div>
    </div>
  )
}

export default connect((state: IAppState) => ({
  userName: selectFullName(state),
}))(React.memo(MenuUserMobile))
